// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CompanyInfo } from './company-info';
import { EducationProtocol } from './education-protocol';
import { FileItem } from './file-item';
import { LearningResourceInfo } from './learning-resource-info';
import { ProtocolInfo } from './protocol-info';
import { StudentInfo } from './student-info';

/**
 * 
 * @export
 * @interface FinalDocument
 */
export interface FinalDocument {
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    id: string;
    /**
     * 
     * @type {EducationProtocol}
     * @memberof FinalDocument
     */
    protocol: EducationProtocol;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    internship?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    graduateWork?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    assignedQualificationRank?: string;
    /**
     * Available values: 0 (in educational organization), 1 (not in educational organization)
     * @type {number}
     * @memberof FinalDocument
     */
    educationalRelations?: number;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    issuedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    expiration?: Date;
    /**
     * Available values: 0 (full-time education), 1 (full-time/part-time education), 2 (part-time education)
     * @type {number}
     * @memberof FinalDocument
     */
    formOfEducation?: number;
    /**
     * Available values: 0 (federal budget), 1 (regional budget), 2 (local budget), 3 (paid training)
     * @type {number}
     * @memberof FinalDocument
     */
    sourceOfFinance?: number;
    /**
     * Available values: 0 (duplicate), 1 (original).
     * @type {number}
     * @memberof FinalDocument
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    certificateSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    registerNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    educationDocument?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    series?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    originalSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    originalNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    originalRegisterNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    originalIssuedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    recipientName?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    recipientMiddleName?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    recipientLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    documentNumberToChange?: string;
    /**
     * Available values: - 0 (No) - 1 (A certificate from the internal affairs bodies) - 2 (A certificate from the fire department) - 3 (Ad in the paper) - 4 (Other)\", type=\"integer\", enum={0, 1, 2, 3, 4})
     * @type {number}
     * @memberof FinalDocument
     */
    confirmOfLoss?: number;
    /**
     * Available values: - 0 (No) - 1 (Exchange due to damage) - 2 (Exchange due to the presence of inaccurate information)
     * @type {number}
     * @memberof FinalDocument
     */
    confirmOfExchange?: number;
    /**
     * Available values: - 0 (No) - 1 (Yes)
     * @type {number}
     * @memberof FinalDocument
     */
    destructionConfirm?: number;
    /**
     * 
     * @type {Array<FileItem>}
     * @memberof FinalDocument
     */
    files?: Array<FileItem>;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    activityArea?: string;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    signedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    updatedAt: Date;
    /**
     * 
     * @type {CompanyInfo}
     * @memberof FinalDocument
     */
    companyInfo?: CompanyInfo;
    /**
     * 
     * @type {ProtocolInfo}
     * @memberof FinalDocument
     */
    protocolInfo?: ProtocolInfo;
    /**
     * 
     * @type {LearningResourceInfo}
     * @memberof FinalDocument
     */
    learningResource?: LearningResourceInfo;
    /**
     * 
     * @type {Array<StudentInfo>}
     * @memberof FinalDocument
     */
    studentInfo?: Array<StudentInfo>;
    /**
     * 
     * @type {boolean}
     * @memberof FinalDocument
     */
    archive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    archivedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FinalDocument
     */
    fisFrdoExportedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    fisFrdoType?: FinalDocumentFisFrdoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FinalDocument
     */
    listenerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FinalDocument
     */
    isFisFrdoExported: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum FinalDocumentFisFrdoTypeEnum {
    ProfessionalEducation = 'professional.education',
    AdditionalProfessionalEducation = 'additional.professional.education'
}



